import '../scss/product-area.scss';

import $ from 'jquery';
import  './product-area/orderable-list';
import productFinder from './product-area/product-finder-filter';

$(document).ready(function () {
    productFinder();
})
